import compose from 'compose-function'
import { withAnalytics } from './with-analytics'
import { withRouter } from './with-router'
import { withStyles } from './with-styles'
import { withTheme } from './with-theme'

export const withProviders = compose(withRouter, withAnalytics, withStyles, withTheme)
